
import { Drawer } from "element-ui"
import dayjs from "dayjs"
import _ from "lodash"
import {
  getOrderDetails,
  deleteOrder,
  buyAgain,
  cancelOrder,
  getCancelReason,
  getRelatedOrderList,
  cancelOrderAfterPaid,
  getReceipt
} from "@/api/order"
import { tooltipCustomStyle } from "@/utils/utils"
import getCartNumMixin from "@/mixins/getCartNum"
import step from "@/components/order/step.vue"
import ware from "@/components/order/ware.vue"
import checkout from "@/components/order/checkoutInfo.vue"
import tooltip from "@/components/tooltip.vue"
import drawerHeader from "@/components/drawer/components/drawerHeader.vue"
import countDown from "@/components/order/countDown.vue"
import { getRootStyle } from "@/utils/head"
export default {
  components: {
    step,
    ware,
    checkout,
    tooltip,
    drawerHeader,
    countDown,
    [Drawer.name]: Drawer
  },
  mixins: [getCartNumMixin],
  provide() {
    return {
      cascaderAsync: () => this.cascaderData
    }
  },
  props: {},
  data() {
    return {
      lang: this.$i18n.locale,
      cascaderData: [],
      breadcrumbData: [],
      orderId: null,
      orderDetails: {},

      orderStatusSvg: "info",
      stepInfo: [],
      wareInfo: {},
      checkoutInfo: [],
      loadingInstance: null,
      hadRequest: false,
      signatureVisable: false,
      signatureTitle: this.$t("orderDetails.checkSignature"),
      curVisible: false,
      reasonOptions: [],
      reason: "",
      cancelTitle: this.$t("orderDetails.cancelReason"),
      relationVisable: false,
      relationTips: "",
      relationTitle: this.$t("orderDetails.cancelOrder"),
      relationBtnText: this.$t("orderDetails.cancelAll"),
      relationOrderList: [],
      reasonPlaceholder: this.$t("orderDetails.reasonPlaceholder"),
      yuuId: "",
      cancelBtnText: this.$t("orderDetails.confirm"),
      btnDisabled: true
    }
  },
  computed: {},
  watch: {},
  async created() {},
  async mounted() {
    document.title = this.$t("pageTitle.order_details")
    await this.init()
  },
  methods: {
    dayjs,
    tooltipCustomStyle(index) {
      return tooltipCustomStyle(index)
    },
    translate(name) {
      return this.$t(name)
    },
    init() {
      this.initBreadcrumb()
      this.hadRequest = false
      const { orderId } = this.$route.query
      this.orderId = orderId
      this.getOrderdDetailsFun()
    },
    initBreadcrumb() {
      const whereFrom = {
        name: this.$t("common.home"),
        path: this.MAIN_PATH_WITHOUT_LANG
      }
      const selPath = [{ name: this.$t("common.orderDetails") }]

      console.log("selPath ", selPath)
      this.breadcrumbData = [whereFrom, ...selPath]
    },
    breadcrumbClick(item) {},
    async getOrderdDetailsFun() {
      try {
        this.hadRequest = false
        const { data } = await getOrderDetails({
          param: JSON.stringify({
            orderId: this.orderId
          })
        })
        if (data) {
          this.orderDetails = data
        }

        const frontOrderVO = this.mapStatus(this.orderDetails.frontOrderVO)
        this.orderDetails = { ...this.orderDetails, ...frontOrderVO }
        this.wareInfo = this.orderDetails.frontOrderVO
        this.checkoutInfo = this.orderDetails.frontOrderVO && this.orderDetails.frontOrderVO.orderItemList
        this.yuuId = this.orderDetails.frontOrderVO && this.orderDetails.frontOrderVO.anfieldUserId
        this.stepInfo =
          this.orderDetails.frontOrderVO.orderTrackingVO && this.orderDetails.frontOrderVO.orderTrackingVO.operations
      } catch (error) {
        console.log(error)
      } finally {
        this.hadRequest = true
      }
    },
    mapStatus(item) {
      const { primaryColor, progressSuccessColor } = getRootStyle()
      item.orderStatusSvg = "info"
      item.orderStatusSvgBIg = "warning"
      item.orderStatusColor = "#000"
      // 待支付1
      if ([1].includes(item.orderStatus)) {
        item.orderStatusSvg = "info"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 已支付 9 等待生產16
      if ([9, 16].includes(item.orderStatus)) {
        item.orderStatusSvg = "coin"
        item.orderStatusSvgBIg = "paid"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 生產中,揀貨中 10
      if ([10].includes(item.orderStatus)) {
        item.orderStatusSvg = "note"
        item.orderStatusSvgBIg = "preparingYourOrder"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 拣货完成14
      if ([14].includes(item.orderStatus)) {
        item.orderStatusSvg = "box"
        item.orderStatusSvgBIg = "readyForDelivery"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 送貨中 12
      if ([12].includes(item.orderStatus)) {
        item.orderStatusSvg = "deliveryCarLeft"
        item.orderStatusSvgBIg = "deliveryCarRightBig"
        item.orderStatusColor = primaryColor
        item.orderStatusSvgColor = primaryColor
      }
      // 已完成4 ,自提已完成5
      if ([4, 5].includes(item.orderStatus)) {
        item.orderStatusSvg = "complete"
        item.orderStatusSvgBIg = "completed"
        item.orderStatusColor = progressSuccessColor
      }

      // 訂單取消 6
      if ([6].includes(item.orderStatus)) {
        item.orderStatusSvg = "closeCircle"
        item.orderStatusSvgBIg = "cancelled"
        item.orderStatusColor = "#969696"
      }
      // 自提 13
      if ([13].includes(item.orderStatus)) {
        item.orderStatusSvg = "readytopickup"
        item.orderStatusSvgBIg = "readytopickupBig"
        item.orderStatusColor = progressSuccessColor
        item.orderStatusSvgColor = progressSuccessColor
      }
      return item
    },

    handleCopy: _.debounce(function (orderId) {
      this.$copyText(String(orderId)).then(res => {
        this.$message({ message: this.$t("orderDetails.copySuccess"), type: "success", duration: 1000 })
      })
    }, 500),
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },

    getNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    handleCheckSignature() {
      this.signatureVisable = true
    },
    handleClose() {
      this.signatureVisable = false
    },
    handleRelationClose() {
      this.relationVisable = false
    },
    handleRelationSave() {
      this.relationVisable = false
      this.curVisible = true
    },
    handleReasonClose() {
      this.curVisible = false
      this.reason = ""
      this.btnDisabled = true
    },
    async handleReasonSave() {
      // if (!this.reason) {
      //   this.$message({ message: "Please Make a choice", type: "warning" })
      //   return
      // }
      this.curVisible = false
      try {
        const orderStatus = this.orderDetails.frontOrderVO.orderStatus
        if (orderStatus == 1) {
          // 支付前cancel
          const res = await cancelOrder({
            param: JSON.stringify({
              causeContent: this.reason.dictName,
              causeId: this.reason.id,
              orderId: this.orderId
            })
          })
          if (res && res.data) {
            this.$message({ message: this.$t("orderDetails.cancelOrderSuccess"), type: "success" })
            setTimeout(() => {
              window.location.reload()
            }, 500)
          }
        } else {
          // 支付后cancel
          const res = await cancelOrderAfterPaid({
            param: JSON.stringify({
              causeContent: this.reason.dictName,
              causeId: this.reason.id,
              orderId: this.orderId
            })
          })
          if (res && res.data) {
            this.$message({ message: this.$t("orderDetails.cancelOrderSuccess"), type: "success" })
            setTimeout(() => {
              window.location.reload()
            }, 500)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleReasonSel(item) {
      this.reasonOptions = this.reasonOptions.map(x => {
        x.isActive = false
        if (item.id == x.id) {
          x.isActive = true
          this.reason = item
          this.btnDisabled = !this.reason
        }
        return x
      })
      this.handleReasonSave()
    },
    async handleBtnClick(it) {
      // it.btnTag = 12
      // 11, "立即支付"
      if (it.btnTag == 11) {
        if (
          this.orderDetails.frontOrderVO.orderTagObj &&
          this.orderDetails.frontOrderVO.orderTagObj.relatedOrderIds &&
          this.orderDetails.frontOrderVO.orderTagObj.relatedOrderIds.length >= 2
        ) {
          this.$messageBox
            .open({
              title: "",
              message: this.$t("orderDetails.pendingPaymentTips"),
              cancelText: this.$t("orderDetails.cancel"),
              confirmText: this.$t("orderDetails.confirmP")
            })
            .then(() => {
              this.$navigation.push({
                path: "/pending_payment",
                query: {
                  orderNo: this.orderDetails.frontOrderVO.orderId
                }
              })
            })
            .catch(res => {
              console.log(res)
            })
        } else {
          this.$navigation.push({
            path: "/pending_payment",
            query: {
              orderNo: this.orderDetails.frontOrderVO.orderId
            }
          })
        }
      }
      // 91 取消订单
      if (it.btnTag == 91) {
        const orderStatus = this.orderDetails.frontOrderVO.orderStatus
        this.reason = ""
        try {
          const res = await getCancelReason({
            param: JSON.stringify({
              dictCodeL1: "4",
              dictCodeL2: "1",
              tradeType: 1
            })
          })
          const { cancelReasons } = res.data
          if (cancelReasons) {
            this.reasonOptions = cancelReasons
          }

          // 待支付 支付前
          if (orderStatus == 1) {
            console.log("支付前cancel")
            if (
              this.orderDetails.frontOrderVO.orderTagObj &&
              this.orderDetails.frontOrderVO.orderTagObj.relatedOrderIds &&
              this.orderDetails.frontOrderVO.orderTagObj.relatedOrderIds.length >= 2
            ) {
              this.$messageBox
                .open({
                  title: "",
                  message: this.$t("orderDetails.ordersFromDifferentStores"),
                  cancelText: this.$t("orderDetails.cancel"),
                  confirmText: this.$t("orderDetails.confirmO")
                })
                .then(() => {
                  this.curVisible = true
                })
                .catch(res => {
                  console.log(res)
                })
            } else {
              this.curVisible = true
            }
          } else {
            // 支付后
            console.log("支付后cancel")
            try {
              const res = await getRelatedOrderList({
                param: JSON.stringify({
                  orderId: this.orderDetails.frontOrderVO.orderId,
                  tradeType: 1
                })
              })
              const { extInfo, allBrotherOrder } = res.data
              if (allBrotherOrder && allBrotherOrder.length) {
                this.relationTips = extInfo && extInfo.content
                this.relationOrderList = allBrotherOrder
                this.relationVisable = true
              } else {
                this.curVisible = true
              }
            } catch (error) {
              console.log(error)
            }
          }
        } catch (error) {
          console.log(error)
        }
      }
      // contact us
      if (it.btnTag == 21) {
        const contactUsLink = this.$t("footer.contactUsLink")
        window.open(contactUsLink)
      }
      // buy again
      if (it.btnTag == 61) {
        try {
          const res = await buyAgain({
            param: JSON.stringify({
              sort: 1,
              orderId: this.orderDetails.frontOrderVO.orderId
            })
          })
          const { message, showBtn } = res.data
          if (message) {
            this.$messageBox
              .open({
                title: this.$t("orderDetails.buyAgain"),
                message,
                cancelText: this.$t("orderDetails.stayHere"),
                confirmText: this.$t("orderDetails.goToCart"),
                showButton: showBtn
              })
              .then(res => {
                this.$navigation.push({ path: "/cart" })
              })
              .catch(res => {
                console.log(res)
              })
          }
        } catch (error) {
          console.log("buy again failed", error)
        }
      }

      // delete order
      if (it.btnTag == 81) {
        this.$messageBox
          .open({
            title: this.$t("orderDetails.deleteOrder"),
            message: this.$t("orderDetails.deleteOrderTips"),
            cancelText: this.$t("orderDetails.deleteOrder"),
            confirmText: this.$t("orderDetails.cancel")
          })
          .then(res => {})
          .catch(async res => {
            try {
              const result = await deleteOrder({
                param: JSON.stringify({
                  orderId: this.orderId
                })
              })
              this.$message({ message: this.$t("orderDetails.deleteOrderSuccess"), type: "success" })
              setTimeout(() => {
                this.$navigation.push({
                  path: "/order_list",
                  query: {
                    page: 1
                  }
                })
              }, 1000)
            } catch (error) {
              console.log(error)
            }
          })
      }
      // 查看收据 ？？
      if (it.btnTag == 96 || it.btnTag == 97) {
        /// / todo
      }
      // 联络我们的送货员
      if (it.btnTag == 56) {
        const deliveryManPhone = this.orderDetails.frontOrderVO.deliveryManPhone || ""
        this.$messageBox
          .open({
            title: this.$t("orderDetails.contactOurDeliveryMan"),
            message: this.$t("address.phone") + ":" + deliveryManPhone,
            confirmText: this.$t("common.confirm"),
            showCancel: false
          })
          .then(res => {})
          .catch(async res => {})
      }
    },
    handleChange(data) {
      console.log(data)
    },

    handleReceipt() {
      // try {
      //   let res = await getReceipt({
      //     param: JSON.stringify({
      //       orderId: this.orderDetails.frontOrderVO.orderId
      //     })
      //   })
      //   const url = `data:application/pdf;base64,${res.data}`
      //   let routerUrl = this.$router.resolve({
      //     path: "/receipt",
      //     query: {
      //       url: url
      //     }
      //   })
      //   window.open(routerUrl.href, "_blank")
      // } catch (error) {
      //   console.log(error)
      // }
      window.open(
        `${this.MAIN_ORIGIN}${this.MAIN_PATH}/receipt?orderId=${this.orderDetails.frontOrderVO.orderId}`,
        "_blank"
      )
    },
    getTootipContent(list) {
      const { childTicketList = [], remarkList = [] } = list
      if (childTicketList && childTicketList.length) {
        const result = childTicketList.map(
          (item, index) => `<div style="display: flex;justify-content: space-between;margin-top: ${
            index === 0 ? "0" : "0.16rem"
          };">
              <span>${item.smallTicketLineName}</span>
              <span>${item.smallTicketLinePriceWithSymbol}</span></div>`
        )

        return result
      }

      return remarkList || []
    }
  }
}
